/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildDto } from '../../models/child-dto';

export interface UserChildControllerFindByNameAndCode$Params {

/**
 * id
 */
  id: string;

/**
 * 이름
 */
  name?: string;

/**
 * 센터 ID
 */
  centerId?: string;
  passException?: any;
}

export function userChildControllerFindByNameAndCode(http: HttpClient, rootUrl: string, params: UserChildControllerFindByNameAndCode$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildDto>> {
  const rb = new RequestBuilder(rootUrl, userChildControllerFindByNameAndCode.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('name', params.name, {});
    rb.query('centerId', params.centerId, {});
    rb.query('passException', params.passException, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildDto>;
    })
  );
}

userChildControllerFindByNameAndCode.PATH = '/api/child/user/load';
